import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Coffee({ className = null }: IconProps) {
    return (
        <div className={classNames(className)}>
            <svg
                width="116.3px"
                height="116.3px"
                viewBox="0 0 116.3 116.3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g>
                    <path
                        d="M116.3,58.1c0,13.8-19.4,20.6-28.4,29.7-9.1,9.1-15.9,28.4-29.7,28.4s-20.6-19.4-29.7-28.4C19.4,78.8,0,72,0,58.1s19.4-20.6,28.4-29.7S44.3,0,58.1,0s20.6,19.4,29.7,28.4c9.1,9.1,28.4,15.9,28.4,29.7Z"
                        fill="#edff9b"
                    />
                    <path
                        d="M58.1,114.7c-13.4,0-19.8-19.2-28.5-28-8.8-8.8-28-15.2-28-28.5s19.2-19.8,28-28.5C38.4,20.8,44.8,1.6,58.1,1.6s19.8,19.2,28.5,28c8.8,8.8,28,15.2,28,28.5s-19.2,19.8-28,28.5c-8.8,8.8-15.2,28-28.5,28Z"
                        fill="none"
                        stroke="#706d20"
                        strokeMiterlimit="10"
                        strokeWidth=".7"
                    />
                    <path
                        d="M58.1,113c-12.9,0-18.9-19-27.4-27.5S3.2,71,3.2,58.1s19-18.9,27.5-27.4S45.2,3.2,58.1,3.2s18.9,19,27.4,27.5,27.5,14.5,27.5,27.4-19,18.9-27.5,27.4c-8.5,8.5-14.5,27.5-27.4,27.5Z"
                        fill="none"
                        stroke="#706d20"
                        strokeMiterlimit="10"
                        strokeWidth=".7"
                    />
                </g>
                <path
                    d="M54.4,87.5h17.3c3.5,0,4.7-4.6,4.7-4.6h-37.3s1.2,4.6,4.7,4.6h10.6Z"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M64.6,82.8c6.9-2.8,11.8-9.6,11.8-17.5v-7.5h-37.3v7.5c0,7.9,4.9,14.7,11.8,17.5"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M76.4,64.3c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9v.4c0,5.3-.8,8.4-6.1,10.7l-10.7,4.6"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M76.4,66.2h1.1c1.1,0,1.9-.9,1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9v.4c0,3.8-.8,6.1-3.8,7.6l-5.3,2.3"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M42.1,65.4c0,6.3,3.4,12.1,9.1,14.6"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <line
                    x1="42.1"
                    y1="62.5"
                    x2="42.1"
                    y2="61"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M59.9,50.1c3.5-4.4,4.1-10.9,1.6-15.9-1.8-3.6-5.1-6.5-5.9-10.5-1-5.3,2.7-10.1,6.2-14.2"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M53.1,50.5c1.7-1.6,3.1-3.5,3.7-5.7s.1-4.8-1.5-6.4c-1.7-1.6-4.1-1.9-6.3-2.6s-4.5-2.3-4.5-4.6"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
                <path
                    d="M66.3,50.4c3.8-2.9,5.7-8,4.7-12.7"
                    fill="none"
                    stroke="#706d20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth=".7"
                />
            </svg>
        </div>
    );
}

export default Coffee;
